(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/components/header-text.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/components/header-text.js');

'use strict';

const {
  SimpleTime: simpleTime
} = svs.utils.date;
const {
  draws: {
    drawsApi
  },
  productMapping
} = svs.numbergames;
const {
  headerText
} = svs.eurojackpot.data.cms;
const HeaderText = () => {
  const jackpotAmountString = svs.eurojackpot.data.jackpots.jackpotAmountString;
  const jackpotText = "Jackpot ".concat(jackpotAmountString);
  const closeTimeWednesday = simpleTime(drawsApi.regCloseTime(productMapping.CONSTANTS.EUROJACKPOT_TUESDAY));
  const closeTimeSaturday = simpleTime(drawsApi.regCloseTime(productMapping.CONSTANTS.EUROJACKPOT_FRIDAY));
  let closeTimeText = "Spelstopp tisdagar kl ".concat(closeTimeWednesday, " och fredagar kl ").concat(closeTimeSaturday);
  if (closeTimeWednesday === closeTimeSaturday) {
    closeTimeText = "Spelstopp ".concat(closeTimeWednesday, " tisdagar och fredagar");
  }
  return React.createElement("div", {
    className: "eurojackpot-start-header-text"
  }, React.createElement("h1", {
    className: ""
  }, jackpotText), React.createElement("p", {
    className: "fc-white game-stopp-text"
  }, closeTimeText), React.createElement("p", {
    className: "fc-white"
  }, headerText));
};
setGlobal('svs.eurojackpot.react.components', {
  HeaderText
});

 })(window);